import {  FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
// import { FaXTwitter } from "react-icons/fa6";
import SecurityNotice from "./SecurityNotice";
import brandLogo from "../assets/brandLogo.png";

const Footer = () => {
  // Graceful fallbacks for environment variables to ensure 100% mockup accuracy if config is empty or whitespace
  const companyName = (import.meta.env.VITE_COMPANY_NAME || "").trim() 
  const companySubheadline = "Empowering working professionals with smart, instant, and transparent credit solutions. Built for the modern career.";
  const companyPhone = (import.meta.env.VITE_COMPANY_PHONE || "").trim();
  const companyEmail = (import.meta.env.VITE_COMPANY_EMAIL || "").trim() ;
  const companyAddress = (import.meta.env.VITE_COMPANY_ADDRESS || "").trim();
  const companyNBFC = (import.meta.env.VITE_COMPANY_NBFC || "").trim() ;
  const companyNBFCLicense = (import.meta.env.VITE_COMPANY_NBFC_LICENSE || "").trim();

  return (
    <>
      <SecurityNotice />

      <footer className="w-full bg-[#161616] text-slate-400 pt-16 pb-8 px-6 lg:px-20 font-sans relative z-10 select-none">
        <div className="max-w-5xl mx-auto flex flex-col gap-10">
          
          {/* Main Content Layout */}
          <div className="flex flex-col lg:grid lg:grid-cols-12 gap-8 lg:gap-10">
            
            {/* Column 1: Logo, Description & Social Icons */}
            <div className="lg:col-span-4 flex flex-col items-center lg:items-start text-center lg:text-left gap-5">
              <div className="flex justify-center lg:justify-start w-full">
                <img
                  src={brandLogo}
                  alt={companyName}
                  className="h-12 sm:h-14 w-auto object-contain"
                />
              </div>
              <p className="text-slate-400 font-medium text-[11px] sm:text-[13px] leading-relaxed max-w-[320px]">
                {companySubheadline}
              </p>
              
              {/* Social Icons Row */}
              {/* <div className="flex justify-center lg:justify-start gap-3 mt-1">
                {[
                  { icon: <FaFacebook />, href: import.meta.env.VITE_COMPANY_FACEBOOK_URL },
                  { icon: <FaXTwitter />, href: "#" },
                  { icon: <FaLinkedin />, href: import.meta.env.VITE_COMPANY_LINKEDIN_URL },
                  { icon: <FaInstagram />, href: import.meta.env.VITE_COMPANY_INSTAGRAM_URL }
                ].map((social, idx) => (
                  <a
                    key={idx}
                    href={social.href || "#"}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-white/[0.04] border border-white/[0.08] flex items-center justify-center text-white text-sm sm:text-lg hover:bg-[var(--primary)] transition-all hover:scale-105"
                  >
                    {social.icon}
                  </a>
                ))}
              // </div> */}
            </div>

            {/* Columns 2-4: Links & Contact (3 cols on mobile, 8 cols on desktop) */}
            <div className="lg:col-span-8 grid grid-cols-3 gap-2 sm:gap-6 mt-4 lg:mt-0">
              
              {/* Column 2: Quick Links */}
              <div className="flex flex-col gap-3">
                <h3 className="text-white font-extrabold text-[11px] sm:text-sm whitespace-nowrap">
                  Quick Links
                </h3>
                <ul className="flex flex-col gap-2.5">
                  {[
                    { label: "About Us", href: "/about" },
                    { label: "How it Works", href: "/#how-it-works" },
                    { label: "Eligibility", href: "/#eligibility" }
                  ].map((link, idx) => (
                    <li key={idx}>
                      <a href={link.href} className="text-slate-400 hover:text-white font-medium text-[9px] sm:text-[13px] transition-colors whitespace-nowrap">
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Column 3: Legal */}
              <div className="flex flex-col gap-3">
                <h3 className="text-white font-extrabold text-[11px] sm:text-sm whitespace-nowrap">
                  Legal
                </h3>
                <ul className="flex flex-col gap-2.5">
                  {[
                    { label: "Privacy Policy", href: "/privacy-policy" },
                    { label: "Terms of Service", href: "/terms-condition" },
                    { label: "Interest Rate Policy", href: "/interest-rate-policy" },
                    { label: "Risk Management Policy", href: "/risk-management-policy" },
                    { label: "KYC & AML Policy", href: "/kyc-aml-policy" },
                    { label: "Corporate Governance", href: "/corporate-governance" },
                    { label: "Fair Practice Code", href: "/fair-practice-code" },
                    { label: "Cancellation & Refund", href: "/cancellation-refund-policy" },
                    { label: "NBFC Partners",href:`${import.meta.env.VITE_COMPANY_NBFC_LINK}` }
                  ].map((link, idx) => (
                    <li key={idx}>
                      <a href={link.href} className="text-slate-400 hover:text-white font-medium text-[9px] sm:text-[13px] transition-colors whitespace-nowrap">
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Column 4: Contact */}
              <div className="flex flex-col gap-3">
                <h3 className="text-white font-extrabold text-[11px] sm:text-sm whitespace-nowrap">
                  Contact
                </h3>
                <ul className="flex flex-col gap-2.5 text-slate-400 font-medium text-[9px] sm:text-[13px]">
                  <li className="flex items-start gap-1.5 sm:gap-2.5">
                    <FaPhone className="w-2.5 h-2.5 sm:w-3.5 sm:h-3.5 flex-shrink-0 text-slate-400 mt-0.5" />
                    <span className="break-all">{companyPhone}</span>
                  </li>
                  <li className="flex items-start gap-1.5 sm:gap-2.5">
                    <FaEnvelope className="w-2.5 h-2.5 sm:w-3.5 sm:h-3.5 flex-shrink-0 text-slate-400 mt-0.5" />
                    <span className="break-all">{companyEmail}</span>
                  </li>
                  <li className="flex items-start gap-1.5 sm:gap-2.5">
                    <FaMapMarkerAlt className="w-2.5 h-2.5 sm:w-3.5 sm:h-3.5 flex-shrink-0 text-slate-400 mt-0.5" />
                    <span className="leading-tight">{companyAddress}</span>
                  </li>
                </ul>
              </div>

            </div>
          </div>

          {/* Divider line */}
          <div className="border-t border-white/[0.08] w-full" />

          {/* Copyright Row */}
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-xs font-semibold text-slate-400 w-full">
            <span className="whitespace-nowrap">
              © {new Date().getFullYear()} {companyName}. All Rights Reserved.
            </span>
            <span className="text-center sm:text-right">
              Powered by {companyNBFC} {companyNBFCLicense && `(RBI License: ${companyNBFCLicense})`}.
            </span>
            <span className="text-center sm:text-right">
              Technology Partner:{" "}
              <a
                href="https://fintechcloud.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white underline-offset-2 hover:underline transition-colors"
              >
                Fintech Cloud Private Limited
              </a>
              .
            </span>

          </div>

          {/* Legal Disclaimer block */}
          <div className="text-slate-600 font-medium text-[10px] sm:text-[11px] leading-relaxed text-center max-w-4xl mx-auto mt-2 border-t border-white/[0.02] pt-4">
            {companyNBFC} is registered with the Reserve Bank of India as a Non-Banking Financial Company (NBFC). Loan approval and disbursement are subject to the company's credit assessment and eligibility criteria. Interest rates are indicative and may vary based on profile. Please read all terms and conditions carefully before availing any financial product. This is not an investment product.
          </div>

        </div>
      </footer>
    </>
  );
};

export default Footer;
